import React from "react";
import { Form, Input, message, Switch } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../../shared/api/AllApi";
import { invalidateCatalog } from "../../../hooks/useCatalogData";
import { FormPage, FormCard, inputStyle, grid2 } from "../../../shared/ui/PageShell";

const AddCustomer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [saving, setSaving] = React.useState(false);

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      const res = await apiClient.post("/customers", values);
      if (res.status === 200 || res.status === 201) {
        invalidateCatalog("customers");
        message.success(t("successMessage", "Form submitted successfully"));
        navigate("/customers");
      }
    } catch (error) {
      if (error?.errorFields) return;
      message.error(error?.response?.data?.message || t("errorMessage", "Failed to submit form. Please try again."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormPage
      breadcrumb={[t("sidebarSectionContacts", "Contacts"), t("customers", "Customers"), t("addCustomer", "Add Customer")]}
      title={t("addCustomer", "Add Customer")}
      subtitle={t("fillCustomerDetails", "Fill in the customer information below")}
      onBack={() => navigate("/customers")}
      onSave={onSave}
      saving={saving}
    >
      <Form form={form} layout="vertical" requiredMark scrollToFirstError>
        <FormCard title={t("customerInfo", "Customer Information")}>
          <div style={grid2}>
            <Form.Item name="name" label={t("name", "Name")} rules={[{ required: true, message: t("enterName", "Enter customer name") }]}>
              <Input placeholder={t("enterName", "Enter customer name")} style={inputStyle} prefix={<UserAddOutlined style={{ color: "#94a3b8" }} />} />
            </Form.Item>
            <Form.Item name="phone_number" label={t("phone", "Phone Number")}>
              <Input placeholder={t("enterPhone", "Enter phone number")} style={inputStyle} />
            </Form.Item>
          </div>
          <Form.Item name="is_pos_default" label={t("posDefaultCustomer", "Default POS Customer")} valuePropName="checked">
            <Switch />
          </Form.Item>
        </FormCard>
      </Form>
    </FormPage>
  );
};

export default AddCustomer;
